import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="error-page">
      <h2>Страница не найдена</h2>
      <p>Такого адреса на сайте нет.</p>
      <p>
        <Link to="/" className="btn">
          На главную
        </Link>
      </p>
    </div>
  );
}
